import { useEffect, useState } from "react";
import { FileUp } from "lucide-react";
import api from "@/api";

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—");
const period = (imp) => {
  const d = imp.coveredDates || [imp.targetDate];
  return d.length > 1 ? `${d[0]} → ${d[d.length - 1]}` : d[0];
};

export const HdjImportHistory = ({ refreshKey }) => {
  const [imports, setImports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    api.get("/hdj/imports").then(({ data }) => alive && setImports(data || [])).catch(() => alive && setImports([])).finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, [refreshKey]);

  if (loading) return <div className="dash-card text-center py-10 text-slate-400 text-sm" data-testid="hdj-import-history-loading">Chargement…</div>;
  if (imports.length === 0) {
    return (
      <div className="dash-card text-center py-10" data-testid="hdj-import-history-empty">
        <FileUp className="w-12 h-12 text-slate-300 mx-auto mb-3" />
        <p className="text-slate-500">Aucun planning importé pour l'instant</p>
      </div>
    );
  }
  return (
    <div className="dash-card overflow-x-auto p-0" data-testid="hdj-import-history">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
          <tr>
            <th className="px-4 py-3">Importé le</th><th className="px-4 py-3">Fichier</th><th className="px-4 py-3">Mode</th><th className="px-4 py-3">Période</th>
            <th className="px-4 py-3 text-right">Appliqués</th><th className="px-4 py-3 text-right">À rapprocher</th><th className="px-4 py-3 text-right">Déplacés</th><th className="px-4 py-3 text-right">Annulés</th>
          </tr>
        </thead>
        <tbody>
          {imports.map((imp) => {
            const s = imp.summary || {};
            return (
              <tr key={imp.id} className="border-t border-slate-100" data-testid={`hdj-import-row-${imp.id}`}>
                <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{fmtDate(imp.createdAt)}</td>
                <td className="px-4 py-3 text-slate-800 font-medium max-w-[220px] truncate" title={imp.fileName}>{imp.fileName}</td>
                <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{imp.mode === "RDV_A_VENIR" ? "RDV à venir" : "Séances du jour"}</td>
                <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{period(imp)}</td>
                <td className="px-4 py-3 text-right font-semibold text-emerald-700">{s.applied ?? "—"}</td>
                <td className={`px-4 py-3 text-right font-semibold ${s.toConfirm ? "text-amber-700" : "text-slate-400"}`}>{s.toConfirm ?? "—"}</td>
                <td className="px-4 py-3 text-right font-semibold text-slate-700">{s.moved ?? "—"}</td>
                <td className={`px-4 py-3 text-right font-semibold ${s.cancelled ? "text-rose-700" : "text-slate-400"}`}>
                  {s.cancelled ?? "—"}{s.blocked > 0 && <span className="ml-1 text-[10px] text-rose-700" title="Annulation automatique bloquée (fichier incomplet ?)">⚠ {s.blocked} bloqués</span>}
                  {s.patientDeclined > 0 && <span className="block text-[10px] text-amber-700">{s.patientDeclined} patient(s) ont décliné</span>}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default HdjImportHistory;
